import { apiClient } from './client';

export interface MaintenanceStatus {
  maintenanceMode: boolean;
  maintenanceStartedAt?: string;
  maintenanceStartedBy?: string;
  maintenanceReason?: string;
}

export async function getMaintenanceStatus(): Promise<MaintenanceStatus> {
  // Dedicated lightweight endpoint — was previously hitting /api/dashboard
  // (which fans out to CloudWatch + DLQ scans + connectivity probes) just to
  // read a single boolean for the banner mounted on every page.
  return apiClient.get<MaintenanceStatus>('/api/system/maintenance');
}

export async function setMaintenanceMode(enabled: boolean, reason?: string): Promise<void> {
  return apiClient.post('/api/system/maintenance', { enabled, reason });
}
